import Suggestion from './suggestion';

export interface ISuggestionGroup {
  heading: string;
  results: Suggestion[];
}

export default class SuggestionCollection {
  public suggestions = [];

  constructor(suggestions: ISuggestionGroup[]) {
    this.suggestions = suggestions;
  }

  get flatSuggestions(): Suggestion[] {
    return this.suggestions.reduce((all, suggestion) => (all.concat(suggestion.results)), []);
  }
}
